import { Link } from "gatsby"
import React from "react"
import { InfoIcon } from "components/page-components/Icons/small"

export const NoticePageCTANotification = ({
  RefIDStringBI = "",
  application_required,
  current_part,
  set_download_update_info_modal_open,
  set_info_notification_open,
  set_message_update_info_modal_open,
}) => {
  const toggle_more_info = (e) => {
    e.preventDefault()
    current_part === "downloads"
      ? set_download_update_info_modal_open(true)
      : set_message_update_info_modal_open(true)
  }
  const close_info_notification = () => set_info_notification_open(false)

  return current_part === "downloads" || current_part === "messages" ? (
    <div className="box has-background-mitternachtsblau-5 is-bordered is-shadowless p-5 m-3">
      <div className="has-text-right">
        <button
          onClick={close_info_notification}
          aria-label="close"
          className="delete is-medium has-background-mitternachtsblau-30"
        ></button>
      </div>
      <div className="columns is-centered pb-5">
        <div className="column is-7">
          <p className="title is-3 has-text-centered has-text-mitternachtsblau">
            Updates zu{" "}
            {current_part === "downloads"
              ? "Unterlagen"
              : "Mitteilungen und Bieterfragen"}
          </p>
          {application_required ? (
            <div className="has-text-mitternachtsblau has-text-centered mx-6">
              Bei Vergabeunterlagen besteht für Bieter die{" "}
              <Link
                to="/vergabe-wissen/lexikon/holschuld-im-vergabeverfahren"
                className="link"
              >
                Holschuld
              </Link>
              .
              <a
                href=" #"
                className="ml-1 is-underlined"
                onClick={toggle_more_info}
              >
                Mehr erfahren
              </a>
              <br />
              Wir empfehler Ihnen, sich{" "}
              <a
                target="_blank"
                href={`https://auftragnehmer.bi-medien.de/de/tendering/${RefIDStringBI}/summary`}
                className="link"
                rel="noopener noreferrer"
              >
                einzuloggen oder zu registrieren
              </a>
              .
            </div>
          ) : (
            <div className="has-text-mitternachtsblau has-text-centered mx-6">
              Bitte{" "}
              <a
                href={`https://auftragnehmer.bi-medien.de/de/tendering/${RefIDStringBI}/summary`}
                className="link"
                target="_blank"
                rel="noopener noreferrer"
              >
                loggen Sie sich ein oder erstellen Sie einen Account
              </a>
              , damit wir Sie
              {current_part === "downloads"
                ? " per E-Mail über Änderungen am Verfahren "
                : " über neue Mitteilungen zur Vergabe "}
              informieren können.
              <a
                href=" #"
                className="ml-1 is-underlined"
                onClick={toggle_more_info}
              >
                Mehr erfahren
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  ) : (
    <div className="has-background-mitternachtsblau mx-3 mt-4 mb-5">
      <div className="columns p-1 is-vcentered">
        <div className="column is-narrow is-flex">
          <InfoIcon {...{ color: "#FFFFFF" }} />
        </div>
        <div className="column has-text-white">
          Um Teilnahmeanträge sowie Angebote abzugeben,{" "}
          <a
            href={`https://auftragnehmer.bi-medien.de/de/tendering/${RefIDStringBI}/summary`}
            target="_blank"
            rel="noopener noreferrer"
            className="link has-text-white"
          >
            loggen Sie sich bitte ein oder erstellen Sie einen Account
          </a>
          .
        </div>
      </div>
    </div>
  )
}
